import produce from 'immer';
import * as helpers from '../helpers';
import { DateTime } from 'luxon';
import { TIME_FORMATS } from '../constants';
import {
    SET_ERROR,
    TOGGLE_LOADING,
    TOGGLE_IS_REFETCH_NEEDED,
    SET_SCHEDULED_BREAKS_DATA,
    TOGGLE_IS_ACTIONS_DISABLED,
    SET_DATE_PICKER_DATA
} from './actions';

const zeroTime = { hours: helpers.hoursOptions(TIME_FORMATS.LONG)[0].value, minutes: helpers.minutesOptions[0].value };
const dateStart = DateTime.local().plus({ days: 1 })
    .toJSDate();
const dateEnd = DateTime.local().plus({ days: 2 })
    .toJSDate();

export const defaultState = {
    revision: '',
    isLoading: true,
    scheduledBreaks: [],
    error: '',
    isFetchError: false,
    isRefetchNeeded: true,
    isActionsDisabled: false,
    dateTimePicker: {
        daily: {
            start: zeroTime,
            end: zeroTime
        },
        weekly: {
            start: { day: helpers.days[0].label, ...zeroTime },
            end: { day: helpers.days[6].label, ...zeroTime }
        },
        onetime: {
            start: { date: dateStart, ...zeroTime },
            end: { date: dateEnd, ...zeroTime }
        }
    }
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_SCHEDULED_BREAKS_DATA:
        case SET_SCHEDULED_BREAKS_DATA + reducerSuffix: {
            const { revision, scheduledBreaks } = action.payload;

            Object.assign(draftState, {
                revision,
                scheduledBreaks
            });

            break;
        }

        case SET_ERROR:
        case SET_ERROR + reducerSuffix: {
            const { error, isFetchError } = action.payload;

            Object.assign(draftState, {
                error,
                isFetchError
            });

            break;
        }

        case TOGGLE_LOADING:
        case TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        case TOGGLE_IS_REFETCH_NEEDED:
        case TOGGLE_IS_REFETCH_NEEDED + reducerSuffix: {
            Object.assign(draftState, {
                isRefetchNeeded: action.payload
            });

            break;
        }

        case TOGGLE_IS_ACTIONS_DISABLED:
        case TOGGLE_IS_ACTIONS_DISABLED + reducerSuffix: {
            Object.assign(draftState, {
                isActionsDisabled: action.payload
            });

            break;
        }

        case SET_DATE_PICKER_DATA:
        case SET_DATE_PICKER_DATA + reducerSuffix: {
            const { form, time, period } = action.payload;

            draftState.dateTimePicker[period][time] = {
                ...draftState.dateTimePicker[period][time],
                ...form
            };

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
